import React from "react";
import EventStreamComponent from "../Components/ActivitiesFeed/EventStream.component";
import { Box, Typography } from "@mui/material";

const EventPage = () => {
  return (
    <Box sx={{
        padding: '20px'
    }}>
      <EventStreamComponent />
    </Box>
  );
};
export default EventPage;
